import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={-0.5}
      y={0.5}
      width={27}
      height={27}
      rx={13.5}
      transform="matrix(-1 0 0 1 27 0)"
      stroke="#1F2A37"
    />
    <path
      d="M15.8666 9.33334L11.2 14L15.8666 18.6667"
      stroke="#1F2A37"
      strokeWidth={1.2}
      strokeLinecap="round"
    />
  </svg>
);

export default SVGComponent;
